import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWebsite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWebsite"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V7.5H21V21ZM6.93945 14.25L9.96973 17.2803L11.0303 16.2197L9.06055 14.25L11.0303 12.2803L9.96973 11.2197L6.93945 14.25ZM12.9697 12.2803L14.9395 14.25L12.9697 16.2197L14.0303 17.2803L17.0605 14.25L14.0303 11.2197L12.9697 12.2803Z" fill="currentColor"/><Path d="M21 6H3V3H21V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWebsite;
